<form aria-label="upload-documents-panel" [formGroup]="form">
  <div>
    @if (uploadMessage) {
      <p-message
        severity="warn"
        icon="pi pi-exclamation-triangle"
        data-test-id="upload-external-messages"
        [closable]="true"
      >
        <p class="font-semibold">{{ uploadMessage.summary }}</p>
        <p>{{ uploadMessage.detail }}</p>
      </p-message>
    }
  </div>
  @if (!limitFour) {
    <div class="grid grid-cols-[1fr_1fr_auto] gap-4 items-start mt-4">
      <div class="flex">
        <label class="mr-2 py-2 font-semibold whitespace-nowrap" for="document-type">
          Document Types:
        </label>
        <div class="document-type">
          <p-multiSelect
            appendTo="body"
            class="p-0 w-full"
            placeholder="Select"
            display="chip"
            formControlName="docTypes"
            id="document-type"
            [displaySelectedLabel]="false"
            [filter]="false"
            [optionDisabled]="setSelectionAbility"
            [options]="documentTypes"
            [selectionLimit]="selectionLimit"
            (onChange)="docTypesSelected($event)"
          >
            <ng-template let-item pTemplate="item">
              @if (item === 'NOMNC Rescind') {
                <div>
                  {{ item }}
                  <i
                    class="pi pi-info-circle"
                    pTooltip="Selecting NOMNC Rescind excludes the possibility of choosing any other document type"
                    tooltipPosition="bottom"
                    tooltipStyleClass="tooltip-xl-size"
                  ></i>
                </div>
              } @else {
                {{ item }}
              }
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
      <div class="flex">
        <label class="mr-2 py-2 font-semibold" for="description">
          Description:
        </label>
        <div class="document-type">
          <div>
            <input
              class="document-type"
              formControlName="description"
              id="description"
              maxlength="40"
              pInputText
              type="text"
            >
            <span
              class="block text-right">{{ form?.get('description').value ? form.get('description').value.length : 0 }} / 40</span>
          </div>
          <app-errors-messages [control]="description"></app-errors-messages>
        </div>
      </div>
      @if (selectedTypes.value?.length > 0) {
        <mnc-documents-document-upload-select
          [accept]="allowedExtensions.join()"
          [authorization]="authorization"
          [authorizationByProductId]="authorizationByProductId"
          [documents]="documents"
          [forceContinuedStayRequest]="forceContinuedStayRequest"
          [isDisabled]="form.invalid"
          [lineData]="lineData"
          [maxFileNameSize]="maxFileNameSize"
          [maxFileSize]="maxFileSize"
          [memberDto]="memberDto"
          [multiple]="false"
          (createContinuedStayUpload)="navigateToCreateContinuedStayPage()"
          (errorValidation)="onError($event)"
          (levelAdjustmentUpload)="handleLevelAdjustmentUpload()"
          (selectFiles)="addFile($event)"
        />
      }
    </div>
  } @else {
    <p-message severity="warn" icon="pi pi-exclamation-triangle" data-test-id="limit-Reached-Message">
      <p class="font-semibold">Warning</p>
      <p>You have reached your limit of 4 files.</p>
    </p-message>
  }

  @if (uploadFiles.length) {
    <div>
      <p-table responsiveLayout="scroll" [value]="uploadFiles">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 15rem">File Name</th>
            <th style="width: 15rem">Document Type</th>
            <th style="width: 9rem">Description</th>
            @if (!isExternal) {
              <th style="width: 9rem">Date/Time Request Received</th>
            }
            <th style="width: 3rem">File Size</th>
            <th style="width: 7rem">&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template let-file let-ri="rowIndex" pTemplate="body">
          <tr>
            <td style="width: 15rem">
                <span tooltipPosition="bottom" [pTooltip]="file.documentFileName">
                  {{ file.documentFileName }}
                </span>
            </td>
            <td style="max-width: 17rem">
                <span class="truncate" tooltipStyleClass="tooltip-xl-size"
                      [pTooltip]="file.documentTypes && file.documentTypes.join(', ')">
                  {{ file.documentTypes && file.documentTypes.join(', ') }}
                </span>
            </td>
            <td style="width: 11rem">
              <div class="p-text-break-word">
                {{ file.description }}
              </div>
            </td>
            @if (!isExternal) {
              <td style="width: 11rem">
                <div class="p-text-break-word">
                  {{ file.dateTimeFaxReceived | date: 'MM/dd/yyyy hh:mm:ss a' }}
                </div>
              </td>
            }
            <td style="width: 3rem">{{ file.fileMetaData.size }} Bytes</td>
            <td class="text-right" style="width: 7rem">
              <button
                class="p-button-text"
                icon="pi pi-trash"
                pButton
                (click)="removeItem(ri)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  @if (uploadFiles.length) {
    <div class="pt-4 flex justify-end upload-button">
      <button
        class="p-button-action"
        label="Save"
        pButton
        type="button"
        [disabled]="isUploading"
        (click)="uploadDocuments();"
      ></button>
    </div>
  }
</form>

<p-confirmDialog
  #cd
  appendTo="body"
  header="Confirmation"
  message="Does this document need to be reviewed by Carelon staff?"
  [closable]="false"
  [closeOnEscape]="false"
>
  <p-footer>
    <button
      class="p-button-action p-button-secondary"
      label="No"
      pButton
      type="button"
      (click)="cd.reject()"
    ></button>
    <button
      class="p-button-action"
      label="Yes"
      pButton
      type="button"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
